export const OTC_SUPPORT_EMAIL = 'otc@paytrie.com'

export const OTC_WIRE_INSTRUCTIONS_PDF_URL =
  'https://storage.paytrie.com/Paytrie_CAD_Wire_Instructions.pdf'

export const isBuyOrder = (leftSideLabel: string): boolean =>
  leftSideLabel.toUpperCase() === 'CAD'
